// extracted by mini-css-extract-plugin
module.exports = {"delete-compare":"DeleteCompareOffer_delete-compare__5Ia2b"};